import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{#if this.isVisible}}\n  <div ...attributes>\n    {{yield}}\n  </div>\n{{/if}}", {
  moduleName: "@customerio/fly-components/components/fly-option-card/content.hbs"
});